import axios from 'axios'

export default axios.create({
  //  baseURL: "https://multiscannerdemo.cyberno.ir", 
 baseURL: window.location.origin,
  headers: {
    "Content-type": "application/json",
    'content-type': 'multipart/form-data',
  }
});